import disposable from "disposable-email";

const invalidValues = [
    {
        domains: [
            "@gmail.",
            "@outlook.",
            "@businessgmail.",
            "@wiemei.",
            "@ullrich.",
            "@hotmail.",
            "@ikrs.",
            "@business.",
            "@memoryblue.",
            "@triots.",
            "@weizixu.",
            "@email.",
            "@work.",
            "@tr.co.uk",
            "@xprimons.",
            "@journey.",
        ],
    },
    {
        domains: ["@icloud.", "@yahoo.", "@live.", "@aol.", "@att.net.", "@msn.", "@sbcglobal."],
        countries: [
            "Argentina",
            "Belize",
            "Bolivia",
            "Bolivia, Plurinational State of",
            "Brazil",
            "Canada",
            "Chile",
            "Colombia",
            "Cuba",
            "Dominican Republic",
            "Ecuador",
            "El Salvador",
            "Falkland Islands (Malvinas)",
            "French Guiana",
            "Guadeloupe",
            "Guatemala",
            "Guyana",
            "Haiti",
            "Honduras",
            "Martinique",
            "Mexico",
            "Nicaragua",
            "Panama",
            "Paraguay",
            "Peru",
            "Puerto Rico",
            "Saint Barthélemy",
            "Saint Martin (French Part)",
            "Sint Maarten (Dutch Part)",
            "South Georgia And the South Sandwich Islands",
            "Suriname",
            "United States of America",
            "United States",
            "Uruguay",
            "Venezuela, Bolivarian Republic of",
        ],
    },
    {
        domains: [
            "@web.",
            "@gmx.",
            "@yahoo.",
            "@bluewin.",
            "@yopmail.",
            "@t-online.",
            "@freenet.",
            "@ionos.",
            "@live.",
        ],
        countries: [
            "Afghanistan",
            "Albania",
            "Algeria",
            "Angola",
            "Armenia",
            "Bahrain",
            "Belarus",
            "Belgium",
            "Bosnia and Herzegovina",
            "Botswana",
            "Bulgaria",
            "Burkina Faso",
            "Burundi",
            "Cameroon",
            "Cape Verde",
            "Central African Republic",
            "Chad",
            "Comoros",
            "Congo",
            "Congo, the Democratic Republic of the;Congo, the Democratic Republic of the",
            "Croatia",
            "Cyprus",
            "Czech Republic",
            "Djibouti",
            "Egypt",
            "Equatorial Guinea",
            "Eritrea",
            "Estonia",
            "Ethiopia",
            "France",
            "French Guiana",
            "French Polynesia",
            "French Southern Territories",
            "Gabon",
            "Gambia",
            "Ghana",
            "Gibraltar",
            "Greece",
            "Grenada",
            "Guinea",
            "Guinea-Bissau",
            "Holy See (Vatican City State)",
            "Hungary",
            "Iran, Islamic Republic of;Iran, Islamic Republic of",
            "Iraq",
            "Israel",
            "Italy",
            "Jordan",
            "Kazakhstan",
            "Kenya",
            "Kuwait",
            "Kyrgyzstan",
            "Latvia",
            "Lebanon",
            "Lesotho",
            "Liberia",
            "Libyan Arab Jamahiriya",
            "Liechtenstein",
            "Lithuania",
            "Luxembourg",
            "Macao",
            "Macedonia, the former Yugoslav Republic of;Macedonia, the former Yugoslav Republic of",
            "Madagascar",
            "Malawi",
            "Mali",
            "Malta",
            "Moldova, Republic of;Moldova, Republic of",
            "Monaco",
            "Mongolia",
            "Montenegro",
            "Montserrat",
            "Morocco",
            "Mozambique",
            "Namibia",
            "Netherlands",
            "Niger",
            "Nigeria",
            "Oman",
            "Pakistan",
            "Palestine",
            "Poland",
            "Qatar",
            "Reunion",
            "Romania",
            "Russian Federation",
            "Rwanda",
            "Cunha",
            "Saint Kitts and Nevis",
            "Saint Lucia",
            "Saint Martin (French part)",
            "Saint Vincent and the Grenadines",
            "Samoa",
            "San Marino",
            "Saudi Arabia",
            "Senegal",
            "Serbia",
            "Sierra Leone",
            "Sint Maarten (Dutch part)",
            "Slovakia",
            "Slovenia",
            "Somalia",
            "South Africa",
            "South Sudan",
            "Sudan",
            "Swaziland",
            "Syrian Arab Republic",
            "Tajikistan",
            "Tanzania, United Republic of;Tanzania, United Republic of",
            "Togo",
            "Tunisia",
            "Turkey",
            "Uganda",
            "Ukraine",
            "United Arab Emirates",
            "Uzbekistan",
            "Wallis and Futuna",
            "Western Sahara",
            "Yemen",
            "Zambia",
            "Zimbabwe",
            "Spain",
            "Portugal",
            "Germany",
            "Austria",
            "Switzerland",
        ],
    },
];

const isEmailDomainInvalid = (domainsList, email) => {
    const exceptionRegex = new RegExp(
        /(((orbantimea.mail(\+([1-9]|[1-9]\d|1[0-4]\d|150))?)|(deancaslin))@gmail.com)|james_maxwell@outlook.com|lararino@hotmail.com/,
        "g"
    );

    if (exceptionRegex.test(email))
        // Testing exception
        return false;

    for (const domain of domainsList) {
        if (email.includes(domain)) return true;
    }

    return false;
};

const isForbiddenCountry = (countriesList, country) => countriesList.includes(country);

export const checkEmailValidity = (email, country) => {
    if (!disposable.validate(email)) return false;

    for (const invalidValue of invalidValues) {
        if (
            (invalidValue.domains &&
                isEmailDomainInvalid(invalidValue.domains, email) &&
                invalidValue.countries &&
                isForbiddenCountry(invalidValue.countries, country)) ||
            (invalidValue.domains &&
                !invalidValue.countries &&
                isEmailDomainInvalid(invalidValue.domains, email))
        )
            return false;
    }

    return true;
};
